import { LoginPage } from '@/containers';

export const Login = () => {
  return <LoginPage />;
};
